import React, { useState } from 'react';
import * as Bixby from '$/core';
import EnterEmail from './EnterEmail';
import { FORGOT_PASSWORD_MESSAGE, FORGOT_PASSWORD_EMAIL, FORGOT_PASSWORD_SENT_MESSAGE } from '$/core/constants';
import { AppState } from '$/store';
import * as ForgotPasswordActions from '$/store/forgot-password/actions';
import { connect } from 'react-redux';
import { ReactComponent as Logo } from '$/assets/BixLogo.svg';
import { Link } from 'react-router-dom';
import Info from '$/components/global/info/Info';

import './index.scss';

const forgotPasswordRequest = ForgotPasswordActions.forgotPasswordRequest;

interface IForgotPasswordProps {
  dispatchForgetPasswordRequest: (ForgotPasswordRequest: Bixby.Models.ForgotPasswordRequest) => Promise<void>;
  isLoading: boolean;
  error?: string;
  success: boolean;
}

const ForgotPassword: React.FC<IForgotPasswordProps> = props => {
  const { isLoading, error, success, dispatchForgetPasswordRequest } = props;
  const [email, setEmail] = useState('');

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSendEmail = async (e: React.FormEvent<HTMLInputElement>) => {
    e.preventDefault();
    try {
      await dispatchForgetPasswordRequest({ email });
    } catch {
      // error is handled via redux
    }
  };

  return (
    <div className="loginPage">
      <div className="content_wrap forgot_password_box">
        <div className="logo_welcome">
          <Logo />
          {FORGOT_PASSWORD_MESSAGE}
        </div>
        <EnterEmail
          email={email}
          isLoading={isLoading}
          error={error}
          success={success}
          onEmailChange={handleEmailChange}
          onSendEmail={handleSendEmail}
          emailPlaceholder={FORGOT_PASSWORD_EMAIL}
          successMessage={FORGOT_PASSWORD_SENT_MESSAGE}
        />
        <Info>
          <Link className="link_underline" to={`/login`}>
            Cancel
          </Link>
        </Info>
      </div>
      <div className="copy_foot">&copy; {new Date().getFullYear()} Bixby Research and Analytics LLC</div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    isLoading: state.forgotPasswordState.isLoading,
    error: state.forgotPasswordState.error,
    success: state.forgotPasswordState.success,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchForgetPasswordRequest: (cmd: Bixby.Models.ForgotPasswordRequest) => dispatch(forgotPasswordRequest(cmd)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
